







import { Component, Vue } from 'vue-property-decorator'
import * as Sentry from '@sentry/vue';
import { Severity } from '@sentry/browser';

@Component
export default class Error extends Vue {
  public supportEmail = process.env.VUE_APP_SUPPORT_EMAIL

  public mounted() {
    Sentry.captureMessage('Error Page Triggered', Severity.Warning)
  }
}
